// @ts-nocheck

// From the new Mapbox GL JS API
// https://github.com/mapbox/mapbox-gl-js/blob/main/src/ui/map.js#L2711
// TODO(catriel): Remove this and use a new version greater than 2.7.1
export function updateContainerDimensions() {
  if (!this._container) {
    return
  }

  const width = this._container.getBoundingClientRect().width || 400
  const height = this._container.getBoundingClientRect().height || 300

  let transformValues
  let transformScaleWidth
  let transformScaleHeight
  let el = this._container
  while (el && (!transformScaleWidth || !transformScaleHeight)) {
    const transformMatrix = window.getComputedStyle(el).transform
    if (transformMatrix && transformMatrix !== 'none') {
      transformValues = transformMatrix.match(/matrix.*\((.+)\)/)[1].split(', ')
      if (transformValues[0] && transformValues[0] !== '0' && transformValues[0] !== '1') {
        transformScaleWidth = transformValues[0]
      }
      if (transformValues[3] && transformValues[3] !== '0' && transformValues[3] !== '1') {
        transformScaleHeight = transformValues[3]
      }
    }
    el = el.parentElement
  }

  this._containerWidth = transformScaleWidth ? Math.abs(width / transformScaleWidth) : width
  this._containerHeight = transformScaleHeight ? Math.abs(height / transformScaleHeight) : height
}
